import React, { useState } from "react";
import PropTypes from "prop-types";

import AddPlayerInterface from "components/AddPlayerInterface";
import { invitePlayer } from "domain/Game/api";
import { gameTypes, userTypes } from "domain/GamesSearch/types";
import Button from "ui/Button";
import InvitationsModalGroupList from "./GroupList";

const InvitationsModal = ({
    invitedUsers,
    updateGameData,
    gameId,
    game,
    isInvate,
}) => {
    const [showModal, setShowModal] = useState(false);

    const inviteUser = async (player) => {
        const response = await invitePlayer(
            gameId,
            player.id,
            "games",
            isInvate
        );
        updateGameData(gameId, response.game);
    };

    return (
        <>
            <Button
                text
                size="medium"
                onClick={() => setShowModal(true)}
                mixes={[`w-100`, `bg-white`]}
                iconLeft={`plus`}
            >
                <span>пригласить игрока / список</span>
            </Button>

            {showModal && (
                <AddPlayerInterface
                    onClose={() => setShowModal(false)}
                    onSelect={inviteUser}
                    selectedUsers={invitedUsers}
                    selectButtonText="Пригласить игрока"
                    multiple
                    successText="Отправлено"
                >
                    <InvitationsModalGroupList
                        gameId={gameId}
                        isInvate={isInvate}
                        invitedGroups={game.players_lists}
                    />
                </AddPlayerInterface>
            )}
        </>
    );
};

InvitationsModal.propTypes = {
    updateGameData: PropTypes.func.isRequired,
    invitedUsers: PropTypes.arrayOf(userTypes),
    gameId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    game: gameTypes,
    isInvate: PropTypes.bool,
};

export default InvitationsModal;
